import { useState } from 'react'

interface WrapAnimationImageProps {
  src_bg: string
  src_fg: string
  height?: number
}

/**
 * Before/after magic-template preview: the "after" image is revealed with a
 * swiping clip animation on hover. Extracted from FilterSection so it can be
 * reused by the dashboard Templates section.
 */
function WrapAnimationImage({ src_bg, src_fg, height }: WrapAnimationImageProps) {
  const [isHover, setIsHover] = useState(false)
  const isFluid = height === undefined
  return (
    <div
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      style={{
        width: isFluid ? '100%' : 'fit-content',
        height: '100%',
        borderRadius: '16px',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <img
        src={src_bg}
        alt={'old'}
        style={
          isFluid
            ? { width: '100%', height: '100%', objectFit: 'cover', borderRadius: '16px' }
            : { height: `${height}px`, borderRadius: '16px' }
        }
        loading="lazy"
      />
      <div
        style={{
          position: 'absolute',
          inset: 0,
          borderRadius: '16px',
          overflow: 'hidden',
          animation: isHover ? 'clipCrop 4s infinite' : 'none',
          zIndex: isHover ? 1 : -1,
        }}
      >
        <img
          src={src_fg}
          alt={'new'}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '16px',
            position: 'absolute',
            inset: 0,
          }}
          loading="lazy"
        />
      </div>
      <div
        style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          width: '2px',
          background: 'white',
          animation: isHover ? 'swipeLine 4s infinite' : 'none',
          zIndex: 1,
          boxShadow: isHover ? '0px 0px 10px 0px rgba(0, 0, 0, 0.80)' : 'none',
          left: '100%',
        }}
      ></div>
      <style>
        {`
          @keyframes clipCrop {
            0% { clip-path: inset(0 0 0 100%); }
            50% { clip-path: inset(0 0 0 0); }
            100% { clip-path: inset(0 0 0 100%); }
          }
          @keyframes swipeLine {
            0% { left: 100%; }
            50% { left: 0%; }
            100% { left: 100%; }
          }
        `}
      </style>
    </div>
  )
}

export default WrapAnimationImage
